import { createAction } from 'redux-actions';
export const ADD_SELECTED_FARE = 'ADD_SELECTED_FARE';
export const SLICE_SELECTED_FARES = 'SLICE_SELECTED_FARES';
export const addSelectedFare = createAction(ADD_SELECTED_FARE, (fare) => fare);
export const sliceSelectedFares = createAction(SLICE_SELECTED_FARES, (legId) => legId);
